import styled from 'styled-components'

const Caption6 = styled.div`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13px;
`

export default Caption6



// WEBPACK FOOTER //
// ./src/components/typography/captions/Caption6.js